<template>
  <GameCategoryLobby :category="category" />
</template>

<script>
  import GameCategoryLobby from '@/components/lobby/GameCategoryLobby.vue';

  export default {
    name: 'GameCategoryLobbyView',

    components: {
      GameCategoryLobby,
    },

    computed: {
      category() {
        return this.$route?.meta?.category || 'all';
      },
    },
  };
</script>
